# Theme variables injected by gulp
THEME_NAME = 'bogen'
angular.module('app.controllers').controller 'BannerGeneratorCtrl', [
  '$scope', '$rootScope', 'APIBanner', 'UI'
].append (self, root, APIBanner, UI) ->

  self.formProccess = false

  self.sizes = [
    {name: '160x600px', sujets: ['']},
    {name: '300x250px', sujets: ['']},
    {name: '300x600px', sujets: ['']},
    {name: '728x90px', sujets: ['']},
    {name: '970x250px', sujets: ['']},
    {name: '970x90px', sujets: ['']}
  ]

  if THEME_NAME is 'kuchen'
    self.sizes.splice(3, 0, {name: '468x60px', sujets: ['','2','3','4']})
  else if THEME_NAME is 'bike' or THEME_NAME is 'bogen' or THEME_NAME is 'fishing'
    if THEME_NAME is 'bike'
      self.sizes.splice(3, 0, {name: '468x60px', sujets: ['']})
    self.sizes.splice(1, 0, {name: '280x90px', sujets: ['']})
  else
    self.sizes.splice(1, 0, {name: '280x93px', sujets: ['']}) if THEME_NAME is not 'garten'


  if THEME_NAME in ['agraria', 'integra']
    self.sizes = [
      {name: '160x600px', sujets: ['']},
      {name: '300x250px', sujets: ['']},
      {name: '728x90px', sujets: ['']},
      {name: '970x90px', sujets: ['']}
    ]

  if THEME_NAME is 'pferd'
    self.sizes.splice(3, 0, {name: '468x60px', sujets: ['']})
    self.sizes.splice(4, 0, {name: '800x200px', sujets: ['']})
    self.sizes.splice(5, 0, {name: '960x720px', sujets: ['']})
    self.sizes.push({name: '1210x400px', sujets: ['']})

  self.setSize = (size) ->
    self.data.size = size
    self.setSujets(size)
    
    if self[self.data.form] && self[self.data.form].$invalid
      return self.data
    
    self.generate()

  self.isSize = (size) ->
    return self.data.size == size

  self.setSujets = (size) ->
    # Get the sujets for the selected size
    sizeConfig = self.sizes.find((s) -> s.name == size)
    # Create sujets objects with proper naming and src
    self.data.sujets = sizeConfig.sujets.map((sujet) ->
      suffix = if sujet == '' then '' else sujet
      return {
        name: size + suffix
        src: 'assets/img/events/' + THEME_NAME + '/banners/Bannergenerator_' + size + suffix + '.png'
      }
    )

  self.resetData = (size = '160x600px', form = '') ->
    self.data =
      form: form
      size: size
      hall: ''
      booth: ''
      src: 'assets/img/events/' + THEME_NAME + '/banners/Bannergenerator_' + size + '.png'
    self.setSujets(size)

  self.saveForm = (form, name) ->
    self[name] = form
    self.resetData('160x600px', name)

  self.generate = () ->

    self.formProccess = true
    
    # Track progress for multiple sujets
    totalSujets = self.data.sujets.length
    completedSujets = 0
    
    # Loop through all sujets and generate each one
    self.data.sujets.forEach((sujet, index) ->
      # Create a copy of data for this specific sujet
      sujetData = angular.copy(self.data)
      sujetData.src = sujetData.sujets[index].src
      sujetData.sujetIndex = index
      sujetData.sujetName = sujet.name
      
      (new APIBanner sujetData).$save {}, (data) ->
        completedSujets++
        
        # Update the specific sujet with the generated result
        self.data.sujets[index].src = data.base64
        self.data.sujets[index].generated = true
        
        # Check if all sujets are completed
        if completedSujets >= totalSujets
          self.formProccess = false
          self[self.data.form].$setPristine()
          self[self.data.form].$setUntouched()

      , (response) ->
        completedSujets++
        self.data.sujets[index].error = response.data.error
        
        # Check if all sujets are completed (even with errors)
        if completedSujets >= totalSujets
          self.formProccess = false
          UI.notify false, "Fehler beim Generieren einiger Banner"
    )
